<template>
  <div class="body-container">
    <div>
      <div class="head-box" v-if="false">
        <div class="nav-box">
          <!-- <a
            @click="handleCutRoute(0, '/')"
            class="nav-item"
            :class="{ active: currentIndex == 0 }"
            >首页
          </a> -->
          <!-- @click="handleCutRoute(1, '/recruitList', { category: 1 })" -->
          <a
            :href="getKechengRouter()"
            class="nav-item"
            :class="{
              active: currentIndex == 1,
            }"
            >找课程
          </a>
          <!-- @click="handleCutRoute(2, '/recruitList', { category: 4 })" -->
          <a
           :href="getRouter()"
            class="nav-item"
            :class="{
              active: currentIndex == 2,
            }"
            >找老师
          </a>
          <a
            @click="handleCutRoute(3, '/recruitList', { category: 5 })"
            class="nav-item"
            :class="{
              active: currentIndex == 3,
            }"
            >欢迎加盟
          </a>
          <!-- <div class="search">
            <input
              type="text"
              placeholder="搜索一下"
              v-model="trainLecturer.name"
            />
            <button @click="getRecruitNoticeList()">搜索</button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="ljgd">
      <div style="position: absolute;left: 20px;margin-top: 50px">
        <div style="cursor: pointer" @click="toCourser">找课程</div>
        <div style="margin:10px 0;cursor: pointer"  @click="toTeacher">找老师</div>
        <div style="cursor: pointer">欢迎入驻</div>
      </div>
      <img src="../../assets/server/zhaomu.jpg" alt="" />
    </div>
    <!-- 推荐课程 -->
    <div class="tjkc">
      <div
        style="
          width: 95%;
          margin: 32px auto;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -ms-flex-wrap: wrap;
          flex-wrap: wrap;
          margin-bottom: 0;
        "
      >
        <div
          class="box_head"
          style="
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
          "
        >
          <span
            class="title"
            style="
              font-size: 36px;
              width: 100%;
              font-weight: 700;
              color: white;
              display: flex;
              justify-content: center;
              margin-top: 30px;
            "
            >推荐课程</span
          >
        </div>
        <div
          class="box_head"
          style="
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
          "
        >
          <span
            class="title"
            style="
              font-size: 16px;
              width: 100%;
              font-weight: 100;
              color: white;
              display: flex;
              justify-content: center;
              margin-top: 10px;
              margin-bottom: 30px;
            "
            >我们不断用心，只为给您提供更好的课程！</span
          >
        </div>
        <div
          class="bk_little_module_shouye_1"
          v-for="(item, index) in courseList"
          :key="index"
        >
            <el-col :span="24" >
              <div class="special_img_shouye_1">
                <img :src="item.pic" style="width: 100%;" />
              </div>
              <div
                class="special_title_shouye_1"
                style="font-size: 22px !important"
              >
                {{ item.title }}
              </div>
              <div
                class="special_title2_shouye_1"
                style="font-size: 15px !important"
              >
               讲师： {{ item.name }}
              </div>
              <div
                style="
                  width: auto;
                  padding: 20px;
                  font-size: 14px !important;
                  font-family: Microsoft YaHei, serif;
                  font-weight: 400;
                  color: #555555;
                  line-height: 28px;
                "
              >
                {{ item.courseContent }}
              </div>
              <div
                style="
                  width: 390px;
                  padding-left: 20px;
                  padding-bottom: 20px;
                  font-size: 15px !important;
                "
              >
                <a  @click="getCourseDetail(item)"
                style="font-weight: bold; color: #002147; line-height: 28px"
                  >查看详情</a
                >
              </div>
            </el-col>
        </div>

        <div
          class="box_head"
          style="
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
          "
        >
          <span
            class="title"
            style="
              font-size: 14px;
              width: 100%;
              font-weight: 100;
              color: white;
              display: flex;
              justify-content: center;
              margin-top: 20px;
              margin-bottom: 20px;
            "
            ><a :href="getCourseRouter()"
            style="font-weight: bold; color: #fff; line-height: 28px"
              >查看所有课程 →</a
            >
          </span>
        </div>
      </div>
    </div>
    <!-- 我要找老师 -->
    <div class="wyzls">
      <div
        style="
          width: 80%;
          margin: 32px auto;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -ms-flex-wrap: wrap;
          flex-wrap: wrap;
          margin-bottom: 0;
        "
      >
        <div
          class="box_head"
          style="
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
          "
        >
          <span
            class="title"
            style="
              font-size: 36px;
              width: 100%;
              font-weight: 700;
              color: white;
              display: flex;
              justify-content: center;
              margin-top: 30px;
            "
            >我要找老师</span
          >
        </div>
        <div
          class="bk_little_module_shouye_2"
          v-for="(item, index) in teacherList"
          :key="index"
        >
          <div class="special_img_shouye_2">
            <img :src="item.pic" style="width: 100%;max-height:180px" />
          </div>
          <div style="width: 100%;" @click="getTeacherDetail(item)">
              <div
                class="special_title2_shouye_2"
                style="font-size: 15px !important"
              >
                {{ item.name }}
              </div>
              <div
                style="
                  font-size: 14px !important;
                  color: #555555;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  line-height: 1.5em;
                  max-height: 4.5em;
                  width: 100%;
                "
              >
                {{ item.aptitude }}
              </div>
          </div>
        </div>

        <div
          class="box_head"
          style="
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
          "
        >
          <span
            class="title"
            style="
              font-size: 14px;
              width: 100%;
              font-weight: 100;
              color: white;
              display: flex;
              justify-content: center;
              margin-top: 30px;
              margin-bottom: 30px;
            "
            ><a :href="getRouter()" style="font-weight: bold; color: #fff; line-height: 28px"
              >查看所有老师 →</a
            >
          </span>
        </div>
      </div>
    </div>
    <!-- 欢迎加盟 -->
    <div class="jm" v-if="false">
      <img
        src="../../assets/server/jiameng_bg_new.png"
        alt=""
        style="width: 100%; height: auto; max-height: 538px"
      />
    </div>
  </div>
</template>

<script>
export default {
  // 数据区
  data() {
    return {

      trainLecturer: {
        name: ""
      },
      courseList:[],
      teacherList:[],
    };
  },
  // 页面加载的时候调用
  created() {
    this.getCourseList();
    this.getTeacherList();
  },
  methods: {
    getCourseList() {
      let _this = this;

      let name = _this.trainLecturer;

      _this.$api.courseZ
        .getCourseShouYeList(name)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.courseList = res.data;
            // if (res.data.length > 0) {

            // }
          }
        })
        .catch(() => {});
    },
    getTeacherList() {
      let _this = this;

      let name = _this.trainLecturer;

      _this.$api.lecturerZ
        .getTeacherShouYeList(name)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {

            _this.teacherList = res.data;

            // if (res.data.length > 0) {

            // }
          }
        })
        .catch(() => {});
    },
    getRouter(){
      return this.$router.resolve({ name: 'specialist' }).href;
    },
    getKechengRouter(){
      return this.$router.resolve({ name: 'allCourse' }).href;
    },
    toCourser(){
      this.$router.push({ name: 'allCourse' })
    },
    toTeacher(){
      this.$router.push({ name: 'specialist' })
    },


    getTeacherDetail(e){
      console.log("e",e)
      return this.$router.push({ name: 'specialist1' ,params:{ id : e.id} }).href;
    },
    getCourseDetail(e){
      return this.$router.push({ name: 'courseDetail' ,params:{ id : e.id} }).href;
    },
    getCourseRouter(){
      return this.$router.resolve({ name: 'allCourse' }).href;
    },

    // 大查询
    getRecruitNoticeList() {
      this.getCourseList();
      this.getTeacherList();


      // let _this = this;
      // let parmas = {
      //   ..._this.recruitNotice,
      //   ..._this.trainLecturer,
      //   pageNum: _this.pageNum,
      //   pageSize: _this.pageSize,
      // };
      // // 判断传递的值是否为空
      // for (let key in parmas) {
      //   if (!parmas[key]) {
      //     delete parmas[key];
      //   } else if (
      //     typeof parmas[key] === "string" &&
      //     parmas[key].trim() === ""
      //   ) {
      //     delete parmas[key];
      //   }
      // }
      // _this.$api.recruitNotice
      //   .getRecruitNoticeList(parmas)
      //   .then((res) => {
      //     if (res.code == this.$commons.RespCode.success) {
      //       _this.recruitNoticeList = res.rows;
      //       if (this.dictList.length > 0) {
      //         this.handleData();
      //       } else {
      //         this.getByDicType();
      //       }
      //       _this.total = Number(res.total);
      //     }
      //   })
      //   .catch(() => {});
    },
  },
};
</script>

<style scoped>
.body-container {
  width: 100%;
  background-color: rgba(164, 171, 189, 0.16);
}
.body-container .ljgd {
  width: 100%;
}
.body-container .ljgd img {
  width: 100%;
}
.body-container .head-box .nav-box {
  display: flex;
  justify-content:center;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 24px;
  /* margin-left: 250px; */
}
.body-container .head-box .nav-box .nav-item {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 18px;
  text-decoration: none;
  cursor: pointer;
  margin-right: 30px;
}

.body-container .head-box .nav-box .nav-item.active {
  color: rgb(64, 112, 179);
  font-weight: 500;
  border-bottom: 3px solid rgb(64, 112, 179);
}

.body-container .head-box .nav-box .nav-item:hover {
  color: rgb(64, 112, 179);
  font-weight: 500;
  border-bottom: 3px solid rgb(64, 112, 179);
  /* transition: all 0.2s; */
}
.body-container .tjkc {
  margin-top: 30px;
  width: 100%;
  max-height: 750px;
  height: auto;
  background-image: url("../../assets/server/courses_bg.png");
}

.body-container .wyzls {
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  max-height: 700px;
  height: auto;
  background-image: url("../../assets/server/teach_bg.png");
}

.body-container .jm {
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  height: auto;
  max-height: 500px;
  /* background-image: url("../../assets/server/jiameng_bg_new.png"); */
}
.form-col-shouye {
  padding-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/server/shouye.vue